export default __webpack_public_path__ + "a83500ce9725f8f003bab4fe8e7e96d1.png";